import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '../modules/dashboard/Dashboard.vue';
import routesGuard from './guard';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Dashboard,
      children: [
        {
          path: '',
          name: 'stats',
          alias: '/',
          component: () => import(/* webpackChunkName: "common" */ '../modules/stats/Stats.vue'),
        },
        {
          path: 'users',
          name: 'users',
          component: () => import(/* webpackChunkName: "common" */ '../modules/users/Users.vue'),
        },
        {
          path: 'products',
          name: 'products',
          component: () => import(/* webpackChunkName: "common" */ '../modules/products/Products.vue'),
        },
      ],
    },
    {
      path: '/auth',
      component: () => import(/* webpackChunkName: "auth" */ '../modules/auth/Auth.vue'),
      children: [
        {
          path: '',
          name: 'login',
          component: () => import(/* webpackChunkName: "auth" */ '../modules/auth/Login.vue'),
        },
        {
          path: 'signup',
          name: 'signup',
          component: () => import(/* webpackChunkName: "auth" */ '../modules/auth/Signup.vue'),
        },
      ],
    },
  ],
});

router.beforeEach(routesGuard);

export default router;
